import { createFileRoute } from "@tanstack/react-router";
import { RentownoscListPage } from "@/features/sys-premiowy/rentownosc-list-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/raporty/system-premiowy/rentownosc/")({
	component: RentownoscListPage,
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.raporty.sys-premiowy-rentownosc",
			location.pathname,
		);
	},
});
